/**
=========================================================
* INTELLIV Panou de Control React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// INTELLIV Panou de Control React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import Socials from "layouts/authentication/components/Socials";
import Separator from "layouts/authentication/components/Separator";

import Swal from "sweetalert2";

// Images
import bgintelliv from "assets/images/curved-images/bg-intelliv.png";
import { Icon } from "@mui/material";

function Basic() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  //onsend
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("username", username.trim());
    formData.append("password", password);

    var url = process.env.REACT_APP_API_URL + "/token";
    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        var token = data.access_token;
        if (token) {
          localStorage.setItem("token", token);
          sessionStorage.removeItem("token");
          window.location.href = "/";
        } else {
          //alert popup using sweetalert2
          Swal.fire({
            icon: "error",
            text: "Credențialele sunt incorecte!",
          });
        }
        console.log(data);
      });
  };

  const toHomePage = () => {
    if (localStorage.getItem("token")) {
      window.location.href = "/";
    }
  };

  useEffect(() => {
    toHomePage();
  }, []);

  return (
    <>
      <SoftBox p={0.5} ml={2} mt={2}>
        <Link to="/">
          <SoftTypography
            component="span"
            variant="body2"
            sx={{ lineHeight: 1 }}
          >
            <img
              src={require("assets/images/logo-ct.png")}
              alt="logo"
              width="30"
            />
          </SoftTypography>
        </Link>
      </SoftBox>
      <BasicLayout
        title="Autentificare"
        description=""
        image={bgintelliv}
        noNav={true}
      >
        <Card>
          <SoftBox p={3}>
            <SoftBox component="form" role="form">
              <SoftBox mb={2}>
                <SoftInput
                  type="user"
                  placeholder="Nume utilizator"
                  onChange={(e) => setUsername(e.target.value)}
                />
              </SoftBox>
              <SoftBox mb={2}>
                <SoftInput
                  type="password"
                  placeholder="parola"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </SoftBox>
              
              <SoftBox mt={4} mb={1}>
                <SoftButton
                  variant="gradient"
                  color="info"
                  fullWidth
                  onClick={handleSubmit}
                >
                  Autentificare
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </BasicLayout>
    </>
  );
}

export default Basic;

/**
 * 
      
 */
